/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intro_Mode_Capitals_DescriptionInputs */

const bn_intro_mode_capitals_description = /** @type {(inputs: Intro_Mode_Capitals_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দেশের পরিবর্তে রাজধানী শহর অনুমান করুন.`)
};

const de_intro_mode_capitals_description = /** @type {(inputs: Intro_Mode_Capitals_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erraten Sie Hauptstädte statt Länder.`)
};

const el_intro_mode_capitals_description = /** @type {(inputs: Intro_Mode_Capitals_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Μαντέψτε πρωτεύουσες αντί για χώρες.`)
};

const en_intro_mode_capitals_description = /** @type {(inputs: Intro_Mode_Capitals_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guess capital cities instead of countries.`)
};

const es_intro_mode_capitals_description = /** @type {(inputs: Intro_Mode_Capitals_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adivina capitales en lugar de países.`)
};

const fr_intro_mode_capitals_description = /** @type {(inputs: Intro_Mode_Capitals_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devinez les capitales au lieu des pays.`)
};

const hi_intro_mode_capitals_description = /** @type {(inputs: Intro_Mode_Capitals_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`देशों के बजाय राजधानी शहरों का अनुमान लगाएं।`)
};

const hu_intro_mode_capitals_description = /** @type {(inputs: Intro_Mode_Capitals_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Találd ki a fővárosokat az országok helyett.`)
};

const id_intro_mode_capitals_description = /** @type {(inputs: Intro_Mode_Capitals_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tebak ibu kota, bukan negara.`)
};

const it_intro_mode_capitals_description = /** @type {(inputs: Intro_Mode_Capitals_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indovina le capitali invece dei paesi.`)
};

const ja_intro_mode_capitals_description = /** @type {(inputs: Intro_Mode_Capitals_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`国の代わりに首都を当ててください。`)
};

const ko_intro_mode_capitals_description = /** @type {(inputs: Intro_Mode_Capitals_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`국가 대신 수도를 추측해 보세요.`)
};

const nl_intro_mode_capitals_description = /** @type {(inputs: Intro_Mode_Capitals_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raad hoofdsteden in plaats van landen.`)
};

const pl_intro_mode_capitals_description = /** @type {(inputs: Intro_Mode_Capitals_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zgadnij stolice zamiast krajów.`)
};

const pt_intro_mode_capitals_description = /** @type {(inputs: Intro_Mode_Capitals_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adivinhe as capitais em vez dos países.`)
};

const ru_intro_mode_capitals_description = /** @type {(inputs: Intro_Mode_Capitals_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Угадайте столицы, а не страны.`)
};

const sv_intro_mode_capitals_description = /** @type {(inputs: Intro_Mode_Capitals_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gissa huvudstäder istället för länder.`)
};

const tr_intro_mode_capitals_description = /** @type {(inputs: Intro_Mode_Capitals_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ülkeler yerine başkentleri tahmin edin.`)
};

const uk_intro_mode_capitals_description = /** @type {(inputs: Intro_Mode_Capitals_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вгадайте столиці замість країн.`)
};

const vi_intro_mode_capitals_description = /** @type {(inputs: Intro_Mode_Capitals_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đoán thành phố thủ đô thay vì quốc gia.`)
};

const zh_intro_mode_capitals_description = /** @type {(inputs: Intro_Mode_Capitals_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`猜猜首都城市而不是国家。`)
};

const zh_hant_intro_mode_capitals_description = /** @type {(inputs: Intro_Mode_Capitals_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`猜猜首都城市而不是國家。`)
};

/**
* | output |
* | --- |
* | "Guess capital cities instead of countries." |
*
* @param {Intro_Mode_Capitals_DescriptionInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const intro_mode_capitals_description = /** @type {((inputs?: Intro_Mode_Capitals_DescriptionInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intro_Mode_Capitals_DescriptionInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_intro_mode_capitals_description(inputs)
	if (locale === "de") return de_intro_mode_capitals_description(inputs)
	if (locale === "el") return el_intro_mode_capitals_description(inputs)
	if (locale === "en") return en_intro_mode_capitals_description(inputs)
	if (locale === "es") return es_intro_mode_capitals_description(inputs)
	if (locale === "fr") return fr_intro_mode_capitals_description(inputs)
	if (locale === "hi") return hi_intro_mode_capitals_description(inputs)
	if (locale === "hu") return hu_intro_mode_capitals_description(inputs)
	if (locale === "id") return id_intro_mode_capitals_description(inputs)
	if (locale === "it") return it_intro_mode_capitals_description(inputs)
	if (locale === "ja") return ja_intro_mode_capitals_description(inputs)
	if (locale === "ko") return ko_intro_mode_capitals_description(inputs)
	if (locale === "nl") return nl_intro_mode_capitals_description(inputs)
	if (locale === "pl") return pl_intro_mode_capitals_description(inputs)
	if (locale === "pt") return pt_intro_mode_capitals_description(inputs)
	if (locale === "ru") return ru_intro_mode_capitals_description(inputs)
	if (locale === "sv") return sv_intro_mode_capitals_description(inputs)
	if (locale === "tr") return tr_intro_mode_capitals_description(inputs)
	if (locale === "uk") return uk_intro_mode_capitals_description(inputs)
	if (locale === "vi") return vi_intro_mode_capitals_description(inputs)
	if (locale === "zh") return zh_intro_mode_capitals_description(inputs)
	return zh_hant_intro_mode_capitals_description(inputs)
});